import React from 'react'
import { Text } from "@fluentui/react";
//import "office-ui-fabric-react/dist/css/fabric.css";

function StadisticCard(props) {

    //Parametros de entrada.
    const inputParam_Item = props.item !== null && props.item !== undefined ? props.item : null;
    const inputParam_ArrayLength = props.arrayLength !== null && props.arrayLength !== undefined ? props.arrayLength : 0;
    const inputParam_Index = props.index !== null && props.index !== undefined ? props.index : 0;
    const inputParam_SelectedItem = props.selectedItem !== null && props.selectedItem !== undefined ? props.selectedItem : null;
    const inputParam_SetterSelectedItem = props.setterSelectedItem !== null && props.setterSelectedItem !== undefined ? props.setterSelectedItem : null;

    const styles = {
        header: {
            root: {
                fontSize: 12,
                fontWeight: "bold",
                padding: "10px"
            }
        },
        amount: {
            root: {
                fontSize: "22px",
                verticalAlign: "middle",
            }
        }
    };

    const onStadisticCardSelected = () => {
        if (inputParam_SelectedItem && inputParam_Item.type === inputParam_SelectedItem.type) {
            inputParam_SetterSelectedItem && inputParam_SetterSelectedItem(null);
        }
        else {
            inputParam_SetterSelectedItem && inputParam_SetterSelectedItem(inputParam_Item);
        }
    }

    return (
        <div onClick={onStadisticCardSelected} className={ inputParam_SelectedItem && inputParam_SelectedItem.type === inputParam_Item.type ? "selected-stadistic-card" : ""} index={inputParam_Index} length={inputParam_ArrayLength}  style={{cursor: "pointer", borderRight: inputParam_ArrayLength > inputParam_Index ? "1px solid #b7b7b7" : ""}}>
            <div style={{display: inputParam_Item.display ? "block" : "none"}}>
                <div className="text-center">
                    <i style={{ fontSize: 20, verticalAlign: "middle", color: inputParam_Item.color}} className={ `ms-Icon ms-Icon--${inputParam_Item.icon}` } ></i>
                    <Text className="ps-1" styles={styles.amount}>{inputParam_Item.amount}</Text>
                </div>
                <div style={{fontSize: "smaller"}} className="text-center">
                    {inputParam_Item.title}
                </div>
            </div>
        </div>
    );
}

export default StadisticCard;

